"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1160],{

/***/ 34553:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(82109);
var $findIndex = (__webpack_require__(42092).findIndex);
var addToUnscopables = __webpack_require__(51223);
var arrayMethodUsesToLength = __webpack_require__(29207);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 27698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24036);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);






var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});





function RichTextLink(props) {
  var _block$getFieldValue, _block$getFieldValue$, _block$getFieldValue$2;

  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z(props);
  var image = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.image */ .yT.image);
  var linkType = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.linkType */ .yT.linkType);
  var title = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.title */ .yT.title);
  var isPDF = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.isPdfLink */ .yT.isPdfLink);
  var url = isPDF ? (_block$getFieldValue = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.asset */ .yT.asset)) == null ? void 0 : (_block$getFieldValue$ = _block$getFieldValue.fields) == null ? void 0 : (_block$getFieldValue$2 = _block$getFieldValue$.file) == null ? void 0 : _block$getFieldValue$2.url : block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__/* .RichTextLinkBlockConstants.url */ .yT.url);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    className: 'ob-rich-text-link',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_7__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
        href: url,
        target: linkType === 'external' ? '_blank' : null,
        children: image ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Image, {
          image: image
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
          children: title
        })
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (RichTextLink);

/***/ })

}]);